import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Auth, Credential } from './model';

@Injectable({
  providedIn: 'root'
})
export class GsLoginService {

  constructor(private http:HttpClient,
    private router:Router,
    @Inject('authConfig') private config:Auth) { }


  login(credential:Credential){
     if(!this.config.clientId){
       console.error("Client Id not provided in the forRoot function")
     }
     else if(!this.config.clientSecret){
      console.error("Client Secret not provided in the forRoot function")
    }
    else if(!this.config.authUrl){
      console.error("Auth Url not provided in the forRoot function")
    }
    else if(!this.config.successUrl){
      console.error("Success Url not provided in the forRoot function")
    }
    else if(!this.config.errorUrl){
      console.error("Error Url not provided in the forRoot function")
    }
    else{
      this.http.post(this.config.authUrl,credential,{
        params:{
          username: credential.username,
          password: credential.password,
          grant_type: "password",
        },
        headers:{
          Authorization: "Basic " + btoa(`${this.config.clientId}:${this.config.clientSecret}`),
        },
        withCredentials:true
      }).subscribe({
        next:()=>{
          this.router.navigateByUrl(this.config.successUrl).catch(err=>{
            console.error(err);
          })
        },
        error:(err)=>{
          if(err.error_description==='Bad credentials'){
            console.error('User credential invalid')
          }
          else{
            console.error(err)
          }
        }
      })
    }


    
  }
}
